var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M853.333333 874.666667H170.666667c-46.933333 0-85.333333-38.4-85.333334-85.333334V234.666667c0-46.933333 38.4-85.333333 85.333334-85.333334h682.666666c46.933333 0 85.333333 38.4 85.333334 85.333334v554.666666c0 46.933333-38.4 85.333333-85.333334 85.333334z",
          fill: "#8CBCD6",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M746.666667 341.333333m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
          fill: "#B3DDF5",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M426.666667 341.333333L192 682.666667h469.333333z",
          fill: "#9AC9E3",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M661.333333 469.333333l-170.666666 213.333334h341.333333z",
          fill: "#B3DDF5",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M810.666667 810.666667m-213.333334 0a213.333333 213.333333 0 1 0 426.666667 0 213.333333 213.333333 0 1 0-426.666667 0Z",
          fill: "#43A047",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M768 682.666667h85.333333v256h-85.333333z",
          fill: "#FFFFFF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M682.666667 768h256v85.333333H682.666667z",
          fill: "#FFFFFF",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }